import React, { useState, useRef, useEffect } from "react";
import useGeneral from '../../../src/hooks/useGeneralContext';
import ICONS from '../layout/icons/icons';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
import Header from "./Header";

const TopNav = ({children}) => {

    const[isOpen ,setIsOpen] = useState(true);
    const sidebarRef = useRef(null);
    const toggleButtonRef = useRef(null);

    const toggle = () => setIsOpen (!isOpen);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1200) {
                setIsOpen(true); 
            } 
  
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // En mobile la barra está abierta como overlay cuando isOpen === false.
    // Cerrarla al hacer click/tap fuera de ella (ignorando la propia barra y el botón hamburguesa).
    useEffect(() => {
        if (isOpen) return; // barra cerrada/oculta: nada que vigilar

        const handleClickOutside = (e) => {
            const inSidebar = sidebarRef.current && sidebarRef.current.contains(e.target);
            const onToggle = toggleButtonRef.current && toggleButtonRef.current.contains(e.target);
            if (!inSidebar && !onToggle) {
                setIsOpen(true);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);

    const {
        sk,
        hpy,
        ss,
        logout
    } = useGeneral();

    const navigate = useNavigate();
    const location = useLocation();

    // Si el operador está en el wizard de un reporte (ruta new_report), avisar antes de
    // salir por los botones del menú (Entradas, Salidas, Cerrar Sesión). WT-922.
    const guardLeave = (proceed) => {
        if (!location.pathname.includes('new_report')) {
            proceed();
            return;
        }
        // Dentro de un reporte: bloqueo duro — solo informar y permanecer en el reporte.
        Swal.fire({
            title: 'Reporte en edición',
            text: 'Tienes un reporte en edición y estás intentando salir.',
            icon: 'warning',
            confirmButtonText: 'Entendido',
            allowOutsideClick: false,
        });
    };

    const handleSignOut = () => {
        axios.delete(process.env.REACT_APP_WAREHOUSE+'logout', {
            data: {},
            params: {
            },
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+hpy+'||'+ss+'||'+sk
            }
        }).then(function (response) {
            logout()
        }).catch(function (error) {
        })
    }

    const menuItem=[
        // {
        //     path:"/",
        //     name:"Dashboard",
        //     icon:ICONS['menu']['inventory']
        // },
        {
            path:"/recibos",
            name:"Entradas",
            icon:ICONS['menu']['warehouse-in']
        },
        {
            path:"/salidas",
            name:"Salidas",
            icon:ICONS['menu']['warehouse-out']
        },
        {
            path:"/contactos",
            name:"Contactos",
            icon:ICONS['menu']['contacts']
        }
    ];

    return (
        <div className="container-nav">
           <div ref={sidebarRef} className={`sidebar z-20 ${isOpen ? 'isClosed' : ''}`}>
                <div className="top_section" >
                </div>
               {
                   menuItem.map((item, index)=>(
                       <NavLink to={item.path} key={index} className="link" activeclassname="active"
                           onClick={(e) => { e.preventDefault(); guardLeave(() => navigate(item.path)); }}>
                           <div className="icon">{item.icon}</div>
                           <div className="link_text">{item.name}</div>
                       </NavLink>
                   ))
               }
                <div className="link" type='button' onClick={() => guardLeave(handleSignOut)}>
                    <div className="icon">{ICONS['menu']['close']}</div>
                    <div className="link_text">Cerrar Sesion</div>
                </div>
           </div>
               {
                typeof isOpen !== 'undefined' ?
                <main>
                    <Header isOpen={isOpen} toggle={toggle} toggleButtonRef={toggleButtonRef}/>
                    <div className={`bodyContainer ${isOpen ? '' : 'isClosed'}`}>
                        {children}
                    </div>
                </main>
                    :
                    ''
               }
        </div>
      );
};

export default TopNav;